import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { PAGE, PageHeader } from '../../app/shell.tsx';
import { ModelsPage, type ModelsTab } from '../../features/model-management/models-page.tsx';

const Search = z.object({
  tab: z.enum(['profiles', 'catalog', 'connections']).optional().catch(undefined),
});

/** `/settings/models`: model profiles, available models and connections (23, ADR-022). */
export const Route = createFileRoute('/_app/settings/models')({
  validateSearch: Search,
  component: SettingsModels,
});

function SettingsModels() {
  const { tab = 'profiles' } = Route.useSearch();
  const navigate = useNavigate({ from: '/settings/models' });
  return (
    <>
      <PageHeader
        title="Models"
        eyebrow={<Link to="/settings">Settings</Link>}
        description="Approved models, versioned model profiles and the configured connections. Changes apply to newly started episode attempts; running attempts keep their pinned version; explicit revocation blocks future calls."
      />
      <div className={PAGE}>
        <ModelsPage
          tab={tab}
          onTab={(t: ModelsTab) =>
            void navigate({
              search: { tab: t === 'profiles' ? undefined : t },
              replace: true,
              resetScroll: false,
            })
          }
        />
      </div>
    </>
  );
}
